import { render } from "./ReleasePendingCases.vue?vue&type=template&id=887fff06"
import script from "./ReleasePendingCases.vue?vue&type=script&lang=js"
export * from "./ReleasePendingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ReleasePendingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "887fff06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('887fff06', __exports__)) {
    console.log('reload')
    api.reload('887fff06', __exports__)
  }
  
  module.hot.accept("./ReleasePendingCases.vue?vue&type=template&id=887fff06", () => {
    console.log('re-render')
    api.rerender('887fff06', render)
  })

}


export default __exports__